/**
 * Password policy, mirroring the express-validator rules on
 * POST /api/users/create, PUT /api/users/:id/password and PUT /api/users/profile.
 * Keep this in step with those routes — the admin panel used to advertise a
 * 6-character minimum and let the server do the rejecting.
 */
export const PASSWORD_RULE = 'at least 8 characters, with an uppercase letter, a lowercase letter and a number';

export const PASSWORD_MIN_LENGTH = 8;

/**
 * @param {string} password
 * @returns {string|null} an error message, or null when the password is acceptable
 */
export function validatePassword(password) {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return `Password must be ${PASSWORD_RULE}`;
  }
  if (!/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/\d/.test(password)) {
    return `Password must be ${PASSWORD_RULE}`;
  }
  return null;
}
